import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UiStateService } from '../../../services/ui-state.service';
import { EventService } from '../../../services/event.service';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';

@Component({
    selector: 'total-raised-dialog',
    templateUrl: './total-raised-dialog.component.html'
})
export class TotalRaisedDialogComponent extends BaseDialogComponent {

    totalRaised:number;
    donationsReceived: number;
    facebookDonationsAmount: number;
    promises: number;
    sponsorships: number;
    isNationalTeam: boolean;

    constructor(
        injector: Injector,
        public activeModal: NgbActiveModal,
        public uiStateService: UiStateService,
        public eventService: EventService
    ) {
        super(injector);
    }
}
